module.exports = __webpack_public_path__ + "static/media/logo-petanjo.196f654b.svg";